import { useTranslation } from 'react-i18next';
import {
  Action,
  ActionsTableMenu,
} from 'src/components/atoms/actions-table-menu';
import { usePermissions } from 'src/permissions/can';

interface Props {
  onEdit: () => void;
  onBlock: () => void;
  isPermanentlyBlocked: boolean;
  hasBlockedState: boolean;
  onUnblock: () => void;
  onDelete: () => void;
}

export const SpacesActionsTableMenu = ({
  onEdit,
  onBlock,
  isPermanentlyBlocked,
  hasBlockedState,
  onUnblock,
  onDelete,
}: Props) => {
  const { t } = useTranslation(['spaces', 'common']);

  const permissions = usePermissions();

  const actions: Action[] = [
    {
      id: 'edit',
      label: t('spaces:common.actions.edit'),
      onClick: onEdit,
      disabled: permissions.cannot('update', 'Spaces'),
      tooltip: t('common:notSufficientPermissions'),
    },
    {
      id: 'block',
      label: t('spaces:common.actions.block'),
      onClick: onBlock,
      disabled: permissions.cannot('block', 'Spaces') || isPermanentlyBlocked,
      tooltip: isPermanentlyBlocked
        ? t('common.permanentBlockTooltip')
        : t('common:notSufficientPermissions'),
    },
    {
      id: 'unblock',
      label: t('spaces:common.actions.unblock'),
      onClick: onUnblock,
      disabled: permissions.cannot('unblock', 'Spaces') || !hasBlockedState,
      tooltip: !hasBlockedState
        ? t('common.notBlockedTooltip')
        : t('common:notSufficientPermissions'),
    },
    {
      id: 'delete',
      label: t('spaces:common.actions.delete'),
      onClick: onDelete,
      disabled: permissions.cannot('delete', 'Spaces'),
      tooltip: t('common:notSufficientPermissions'),
    },
  ];

  return <ActionsTableMenu actions={actions} />;
};
